import axios from 'axios'
export default {
    index(nombreCategoria, sucursal_uuid, isGlobal, uso = null) {
        if (!nombreCategoria) {
            nombreCategoria = 'CATEGORIA';
        }
        console.log(sucursal_uuid);


        let url = `/categorias/categorias?name=${nombreCategoria}`;
        if (sucursal_uuid) {
            url += `&uuid_s=${sucursal_uuid}`;
        }
        if (isGlobal) {
            url += `&global=true`;
        }
        if (uso) {
            url += `&uso=${uso}`;
        }

        return axios.get(url);
    },
    indexInventarioFilters(nombreCategoria, sucursal_uuid) {

        if (!nombreCategoria) {
            nombreCategoria = 'CATEGORIA';
        }
        let url = `/categorias/categorias-inventario?name=${nombreCategoria}`;
        if (sucursal_uuid) {
            url += `&uuid_s=${sucursal_uuid}`;
        }
        return axios.get(url)
    },
    // Renombrada a 'indexInventarioFilters' para evitar conflicto con 'index' en 'src/api/
    indexFilters() {
        var url = "/categorias/categorias/filters";
        return axios.get(url)
    },
    unificar(categorias) {
        var url = "/categorias/empresa/unificar";
        return axios.post(url, categorias)
    },
    toggleAsignacion(sucursal_uuid, categoria_id, asignado) {
        console.log("toggleAsignacion", sucursal_uuid, categoria_id, asignado);

        const url = `/categorias/categorias/asignar-sucursal`;
        return axios.post(url, {
            sucursal_uuid: sucursal_uuid,
            categoria_id: categoria_id,
            asignado: asignado // true para añadir, false para quitar
        });
    },
    uploadImagen(id, formData) {
        return axios.post(`/categorias/${id}/imagen`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    deleteImagen(id) {
        return axios.delete(`/categorias/${id}/imagen`);
    }

}